"use client";
import { useEffect, useState } from "react";
import SliderHomeServer from "./index.server";
import SliderHomeClient from "./index.client";

export default function SliderHome(props) {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return <SliderHomeServer {...props} />;
  }

  return <SliderHomeClient {...props} />;
}
